import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../dynamicFormBuilder/FormField'
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import { WMDefaultsLayout } from "../../common/Layouts";
import data from "../../../assets/apiRoutes.json";
import {
    Column,
    DataGrid,
    Summary, TotalItem,
    Selection,
    Toolbar as GridToolbar,
    Item as GridItem
} from "devextreme-react/data-grid";
import { Button, NumberBox, SelectBox, TextArea, TextBox } from 'devextreme-react';

import axios from "axios";
import { alert, confirm } from 'devextreme/ui/dialog';

const LotElementType = [{ id: 'User', name: 'User Defined Text' }, { id: 'D/T', name: 'Date/Time Value' }, { id: 'Num', name: 'Incrementing Number' }]

function WMDefaultsTab(props) {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    var currentUser = props.oidc.user;
    const formRefs = useRef({});
    const [selectedItemKeys, setSelectedItemKeys] = useState([]);
    const [selectedGenerate, setGenerate] = useState('N');
    const [selectedLotElementType, setLotElementType] = useState('User');
    const [selectedFormatedText, setFormatedText] = useState('');
    const [formatsDatasource, setFormatsDatasource] = useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [saveFormat, setSaveFormat] = useState(false);
    const [generateFormat, setGenerateFormat] = useState('');

    const isInitialRender = useRef(true);
    const dataGridRef = React.createRef();


    const AdditionalFormLoad = useCallback(() => {
        props.wmDefaultsFormLookupsLoad(formRefs);
    }, []);
    useEffect(() => {
        if (props.formFields.ROWID !== '00000000-0000-0000-0000-000000000000')
            loadSublotFormats();
    }, [props.formFields.ROWID]);
    useEffect(() => {
        if (isInitialRender.current) {
            isInitialRender.current = false;
            return;
        }
        if (formatsDatasource !== undefined) {
            updateSubLotFormats();
            dataGridRef.current.instance().refresh();
        }
    }, [saveFormat]);

    const handleValueChanged = (e) => {
        setGenerate(e.value);
        if (e.previousValue !== e.value && e.event) {
            setSaveFormat(prev => !prev);
        }
    };

    const loadSublotFormats = async () => {
        try {
            const res = await axios.get(
                `${window._env_.REACT_APP_APIS}/${data.AB.GetAbtransnumsetup}?rowid=${props.formFields.ROWID}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`
                    }
                }
            );
            if (res.data) {
                if (res.data.generateformat) {
                    setGenerateFormat(res.data.generateformat);
                    let data = reverseStringFormat(res.data.generateformat);
                    setFormatsDatasource(data);
                }
                if(res.data.generatetransno)
                  setGenerate(res.data.generatetransno);
            } else {
                setFormatsDatasource(null);
            }
        } catch (err) {
            console.log(err, "Error while getting databases");
        }
    }
    const handleFieldChange = useCallback((name, value, e) => {

    }, []);

    const handleSelectionChange = useCallback((name, e) => {
    }, []);
    const onSelectionChanged = (e) => {
        setSelectedRowKeys(e.selectedRowKeys);
    };

    // Remove selected row
    const removeSelectedRow = () => {
        if (selectedRowKeys.length > 0) {
            const newData = formatsDatasource.filter(row => !selectedRowKeys.includes(row.id));
            setFormatsDatasource(newData);
            setSaveFormat(!saveFormat);
        }
    };
    const deleteRecords = useCallback(() => {
        removeSelectedRow();
    });
    const addData = () => {
        const num = formatsDatasource?.find(item => item?.name?.includes("Num: ")) ?? null;
        if(num && selectedLotElementType === 'Num'){
            alert('You can only have one incrementing number element in transaction number format.', 'Error');
            return;
        }
        let val = '';
        if (selectedLotElementType === 'D/T') {
            val = selectedFormatedText.toUpperCase();
        }
        else {
            val = selectedFormatedText;
        }
        let text = selectedLotElementType + ': ' + val;
        let format = '';
        if (formatsDatasource.length > 0 && formatsDatasource !== null && formatsDatasource !== undefined && formatsDatasource !== '') {
            const singleString = formatsDatasource.map(item => `${item.name}`).join(", ");
            format = convertStringFormat(singleString);
        }
        let totalDigits = format.length + selectedFormatedText.length;
        if (totalDigits > 36) {
            alert('Adding element would exceed maximum length of 20 characters.', 'Error');
            return;
        }
        setFormatsDatasource([...formatsDatasource, { id: formatsDatasource.length + 1, name: text }]);
        setSaveFormat(!saveFormat);
        setFormatedText('');
        setLotElementType('User');
    }
    function convertStringFormat(input) {
        if (input === '' || input === null || input === undefined) {
            return null;
        }
        const replacements = {
            'User': 'l',
            'D/T': 'd',
            'Num': 'i'
        };

        // Split the string into key-value pairs
        const pairs = input.split(', ');

        let result = '';

        pairs.forEach(pair => {
            const [key, value] = pair.split(': ');
            const shortKey = replacements[key] || key;

            // Add backslash and the transformed pair
            result += `\\${shortKey}${value}`;
        });

        return result;
    }
    function reverseStringFormat(input) {
        if (input === '' || input === null || input === undefined) {
            return null;
        }
        const replacements = {
            'l': 'User',
            'd': 'D/T',
            'i': 'Num'
        };

        // Split the string by backslashes and filter out empty strings
        const parts = input.split('\\').filter(part => part !== '');

        return parts.map((part, index) => {
            // Extract the type code (first character) and the value (remaining characters)
            const typeCode = part[0];
            const value = part.substring(1);

            // Get the full name from replacements or use the code if not found
            const fullName = replacements[typeCode] || typeCode;

            return {
                id: index + 1,
                name: `${fullName}: ${value}`
            };
        });
    }

    const updateSubLotFormats = () => {
        let format = null;
        if (formatsDatasource.length > 0 && formatsDatasource !== null && formatsDatasource !== undefined && formatsDatasource !== '') {
            const singleString = formatsDatasource.map(item => `${item.name}`).join(", ");
            format = convertStringFormat(singleString);
        }
        axios.put(
            `${window._env_.REACT_APP_APIS}/${data.AB.UpdateAbTransNumSetup}`,
            {
                RSourceid: props.formFields.ROWID,
                Generateformat: format,
                Generatetransno: selectedGenerate,
                Module: "WM",
                Sourcetablename: "IDCUSTOMER",
                Transactiontype: "B",
            },
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                },
            }
        )
            .then((res) => {
                setGenerateFormat(format);

            })
            .catch((err) => {
            });
    }
    const calculateCustomSummary = (options) => {
        if (options.name == "formatSummary") {
            if (options.summaryProcess === "start") {
                options.totalValue = '';
            }
            if (options.summaryProcess === "calculate") {

                options.totalValue = getFormat();
            }
        }

    }
    function formatDate(format) {
        var date = new Date();
        // Date components
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const seconds = date.getSeconds();
        const dayOfWeek = date.getDay();

        // Text values
        const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        const fullDayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const fullMonthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

        // Padding helper
        const pad = num => num.toString().padStart(2, '0');

        // Format replacement map
        const formats = {
            // Day formats
            'D': day.toString(),
            'DD': pad(day),
            'DDD': dayNames[dayOfWeek],
            'DDDD': fullDayNames[dayOfWeek],
            'DDDDD': `${month}/${day}/${year}`,
            'DDDDDD': `${fullDayNames[dayOfWeek]}, ${fullMonthNames[month - 1]} ${day}, ${year}`,

            // Month formats
            'M': month.toString(),
            'MM': pad(month),
            'MMM': monthNames[month - 1],
            'MMMM': fullMonthNames[month - 1],

            // Year formats
            'YY': year.toString().slice(-2),
            'YYYY': year.toString(),

            // Time formats
            'H': hours.toString(),
            'HH': pad(hours),
            //'M': minutes.toString(),
            //'MM': pad(minutes),
            'S': seconds.toString(),
            'SS': pad(seconds)
        };

        // Replace all format patterns (case-sensitive)
        return format.replace(
            /D{1,6}|M{1,4}|Y{2,4}|H{1,2}|S{1,2}/g,
            match => formats[match] || match
        );
    }
    const getFormat = () => {
        let str = '';
        let datestr = '';

        const parts = generateFormat?.split('\\').filter(part => part !== '');
        if (parts) {
            parts.map((part, index) => {

                const typeCode = part[0];
                let value = part.substring(1);

                if (typeCode === 'd') {
                    value = datestr + formatDate(value);
                }
                str = str + value;
            });
        }

        return str;
    }
    return (
        <>
            <div className="FormMt">
                <FormField
                    currrentUser={currentUser}
                    layoutId='B38F8A0E-0427-442D-B7E9-179AAA47AC8C'
                    layoutName='WMDefauts'
                    defaultFormSchema={WMDefaultsLayout}
                    formFields={props.formFields}
                    setformFields={props.setformFields}
                    handleFieldValueChange={handleFieldChange}
                    handleSelectedItemChange={handleSelectionChange}
                    DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                    formRefs={formRefs}
                    onFormLoad={AdditionalFormLoad}
                    noSpacingBeforeFirstRow={true}
                />
            </div>

            <div className="row">
                <div className="col-md-3">
                    <TextArea className="mt-3" height='300px' text="Note: Selecting  'By 
                                Transaction' for either 
                                Item or Transaction 
                                charges will create a 
                                single 
                                Invoice 
                                for 
                                each WM Transaction. 
                                Both Item and 
                                Transaction charges will be 
                                attached to 
                                that 
                                single 
                                Invoice."/>
                </div>

                <div className="col-md-9">
                    <fieldset className={'col-fieldset'} style={{ margin: '10px' }} >
                        <legend className="list-title" >Sub Lot Code Generation</legend>
                        <div className="row">
                            <div className="col-md-3">

                                <SelectBox
                                    labelMode='static'
                                    stylingMode='outlined'
                                    label="Generate #"
                                    displayExpr='name'
                                    valueExpr='id'
                                    value={selectedGenerate}
                                    dataSource={[{ id: 'Y', name: "Yes" }, { id: 'N', name: "No" }]}
                                    onValueChanged={handleValueChanged}
                                />
                            </div>
                            <div className="col-md-3">

                                <SelectBox labelMode='static'
                                    stylingMode='outlined'
                                    label="Element"
                                    displayExpr='name'
                                    valueExpr='id'
                                    value={selectedLotElementType}
                                    dataSource={LotElementType}
                                    onValueChanged={(e) => {setLotElementType(e.value);setFormatedText('')}}
                                    disabled={selectedGenerate === 'N'} 
                                />
                            </div>
                            <div className="col-md-3">
                                {
                                    selectedLotElementType === 'User' && (

                                        <TextBox labelMode='static'
                                            stylingMode='outlined'
                                            label="Text"
                                            value={selectedFormatedText}
                                            maxLength={20}
                                            onValueChanged={(e) => setFormatedText(e.value)}
                                            disabled={selectedGenerate === 'N'} 
                                            />
                                    )}
                                {
                                    selectedLotElementType === 'D/T' && (

                                        <TextBox labelMode='static'
                                            stylingMode='outlined'
                                            label="Text"
                                            value={selectedFormatedText}
                                            maxLength={20}
                                            inputAttr={{ style: "text-transform: uppercase" }} 
                                            onValueChanged={(e) => setFormatedText(e.value.toUpperCase())}
                                            disabled={selectedGenerate === 'N'} 
                                        />
                                    )}
                                {selectedLotElementType === 'Num' && (<NumberBox labelMode='static'
                                    stylingMode='outlined'
                                    label="Text"
                                    value={selectedFormatedText}
                                    maxLength={20}
                                    onValueChanged={(e) => setFormatedText(e.value)}
                                    disabled={selectedGenerate === 'N'} 
                                />
                                )
                                }

                            </div>
                            <div className="col-md-3">
                                <Button className="mt-2" text="Add" type="default" onClick={addData} disabled={selectedGenerate === 'N'} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                                    ref={dataGridRef}
                                    dataSource={formatsDatasource}
                                    showRowLines={true}
                                    showBorders={true}
                                    columnAutoWidth={true}
                                    disabled={selectedGenerate === 'N'}
                                    remoteOperations={false}
                                    keyExpr="id"
                                    onSelectionChanged={onSelectionChanged}

                                >
                                    <Selection mode="single" />

                                    <Column
                                        dataField="name"
                                        caption='Format'
                                        allowEditing={false}
                                    />
                                    <Summary calculateCustomSummary={calculateCustomSummary}>
                                        <TotalItem
                                            name="formatSummary"
                                            summaryType="custom"
                                            displayFormat="Example: {0}"
                                            showInColumn="name"
                                        />
                                    </Summary>
                                    <GridToolbar>
                                        <GridItem location="after">
                                            <Button
                                                onClick={deleteRecords}
                                                icon="trash"
                                                disabled={!selectedRowKeys.length}
                                            />
                                        </GridItem>
                                    </GridToolbar>
                                </DataGrid>
                            </div>
                        </div>
                    </fieldset>

                </div>
            </div>

        </>
    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(WMDefaultsTab);